import { useMemo } from 'react';
import { getGlobalSettings } from 'app/appState';
import { AppLanguage } from 'app/config/i18Config/types';
import { useAppSelector } from 'app/config/storeConfig/hooks';

export const useDefaultLocalizedDescription = (): string => {
  const globalSettings = useAppSelector(getGlobalSettings);

  const defaultLocalizedDescription = useMemo(() => {
    const availableLanguages = globalSettings?.availableLanguages || [];

    const descriptionTemplate = availableLanguages.reduce<Partial<Record<AppLanguage, string>>>((acc, lang) => {
      acc[lang as AppLanguage] = '';
      return acc;
    }, {});

    return JSON.stringify(descriptionTemplate as Record<AppLanguage, string>, null, 2);
  }, [globalSettings?.availableLanguages]);

  return defaultLocalizedDescription;
};
